import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import {
  AsnCreateDto,
  OrderDetailReturnReasonPatchDto,
  PreInboundCreateDto
} from '../types'
import { Filter } from '../../_WMS/FilterComponent'

export const createAsn = (dto: AsnCreateDto) => {
  const url = new URL(`${ApiConfig.AsnApi}`)
  return axios.post(url.toString(), dto)
}

export const getOrderDevolution = (searchBy: string, searchValue: string) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/OrderRelatedData?${searchBy}=${searchValue}`
  )
  return axios.get(url.toString())
}

export const getOrderDevolutionFromWorkOrder = (
  workOrderId: number,
  orderId?: number
) => {
  const url = new URL(
    `${
      ApiConfig.AsnReturnApi
    }/WorkOrder/${workOrderId.toString()}/OrderDetailRelatedData`
  )

  if (orderId) {
    url.searchParams.set('orderId', orderId.toString())
  }
  return axios.get(url.toString())
}


export const getPreInboundReason = () => {
  const url = new URL(`${ApiConfig.PreInboundReason}?pageIndex=0&pageSize=100`)
  return axios.get(url.toString())
}

// Grilla principal
export const getAsnReturn = (filters?: Filter[], page = 0, pageSize = 5) => {
  const url = new URL(`${ApiConfig.AsnReturnApi}`)
  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (element.key === 'externalStatusId') {
        url.searchParams.set('statusId', element.value)
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.get(url.toString())
}

// Crear Pre-Asn
export const createPreInbound = (dto: PreInboundCreateDto) => {
  const url = new URL(`${ApiConfig.PreInbound}`)
  return axios.post(url.toString(), dto)
}

export const cancelPreAsn = (preInboundId: number) => {
  const url = new URL(`${ApiConfig.PreInbound}/${preInboundId}/cancel`)
  return axios.delete(url.toString())
}

export const softDeleteAsn = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/SoftDelete?asnId=${asnId}`)
  return axios.delete(url.toString())
}

export const cancelAsn = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/CancelAsnAsync/${asnId}`)
  return axios.put(url.toString())
}

// Api busqueda información para formulario de selección de Lotes
export const AsnReturnOrderDetailReturnBatches = (
  preInboundId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/PreInbound/${preInboundId}/OrderDetailReturnBatches`
  )

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

// Grilla Step calidad
export const getQualityControlDetail = (
  sku: string | undefined,
  asnId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.AsnReturnApi}/${asnId}/QualityControlDetail`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (sku && sku !== undefined) url.searchParams.set('sku', sku)

  return axios.get(url.toString())
}

// Actualiza datos de Control de Calidad por Detalle de Pedido Devuelto y su Motivo de Devolución
export const patchOrderDetailReturnReason = (
  asnId: number,
  orderDetailReturnReasonId: number,
  orderDetailReturnReasonPatchDto: OrderDetailReturnReasonPatchDto
) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/${asnId}/OrderDetailReturnReasons/${orderDetailReturnReasonId}`
  )

  return axios.patch(url.toString(), orderDetailReturnReasonPatchDto)
}
